import React, {PropsWithChildren} from 'react';
import {StyleSheet} from 'react-native';
type propsType = Readonly<
  PropsWithChildren<{
    fileType: string;
    onFileUpload: (value: File) => void;
  }>
>;

export default function ImagePicker(props: propsType) {
  const {fileType, children, onFileUpload} = props;

  function handleFileUpload(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) {
      onFileUpload(file);
    }
  }

  return (
    <>
      <input
        type={'file'}
        id="file"
        accept={fileType}
        onChange={handleFileUpload}
        style={styles.hiddenInput}
      />
      <label htmlFor={'file'} style={styles.label}>
        {children}
      </label>
    </>
  );
}

const styles = StyleSheet.create({
  hiddenInput: {
    display: 'none',
  },
  label: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});
